import EnvironmentAlert from './EnvironmentAlert'

export default EnvironmentAlert
